import React, { useState } from 'react';
import Icon from './UI/Icon';
import './Contact.css';

const Contact = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    symptoms: '',
    date: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.phone) return;
    
    // Simulate successful submission
    setFormSubmitted(true);
  };

  const handleWhatsAppSubmit = () => {
    const message = `Hello Dr. Anil Kumar (PT), I would like to request a callback.\nName: ${formData.name}\nPhone: ${formData.phone}\nSymptoms: ${formData.symptoms}\nPreferred Date: ${formData.date}`;
    const url = `https://wa.me/918826265224?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section id="contact" className="section bg-navy">
      <div className="container contact-container">
        
        <div className="grid-2 contact-grid">
          
          {/* Left Column: Direct Clinic Contact Details & Patient Trust Gallery */}
          <div className="contact-info animate-fade-in-up">
            <span className="section-tag">Booking Center</span>
            <h2 className="section-title">Schedule a Consultation</h2>
            
            <p className="contact-lead-text">
              We look forward to helping you recover. Contact us directly or fill out the form, and our clinic assistant will call you back shortly.
            </p>

            <div className="contact-details-list">
              {/* Phone Numbers */}
              <div className="contact-item">
                <div className="contact-icon-bg">
                  <Icon name="phone" size={20} />
                </div>
                <div className="contact-text">
                  <h4>Call Clinic</h4>
                  <div className="contact-links">
                    <a href="tel:8826265224">8826265224</a>
                    <span className="link-divider">|</span>
                    <a href="tel:8840300344">8840300344</a>
                  </div>
                </div>
              </div>

              {/* Emails */}
              <div className="contact-item">
                <div className="contact-icon-bg">
                  <Icon name="mail" size={20} />
                </div>
                <div className="contact-text">
                  <h4>Email Us</h4>
                  <div className="contact-links">
                    <a href="mailto:activejoint1@gmail.com">activejoint1@gmail.com</a>
                    <br />
                    <a href="mailto:sanil4508@gmail.com">sanil4508@gmail.com</a>
                  </div>
                </div>
              </div>

              {/* Location Embed / Address details */}
              <div className="contact-item">
                <div className="contact-icon-bg">
                  <Icon name="mappin" size={20} />
                </div>
                <div className="contact-text">
                  <h4>Clinic Address</h4>
                  <p className="address-text">
                    Active Joint Physiotherapy Centre, G-7, Kristal Heights, Sector-1  (Behind Ace City) Gr.Noida West 201318
                  </p>
                  <a 
                    href="https://maps.app.goo.gl/QzBQBePeT7Q6gkc37" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="maps-direction-btn"
                  >
                    <span>Get Directions on Google Maps</span>
                    <Icon name="externallink" size={14} />
                  </a>
                </div>
              </div>
            </div>

            {/* Patient trust block featuring the family selfie */}
            <div className="patient-trust-card glass-card">
              <div className="trust-card-grid">
                <div className="trust-card-image-wrapper">
                  <img 
                    src="/assets/doctor_patients.jpg" 
                    alt="Dr. Anil Kumar with patients and children" 
                    className="trust-card-image"
                  />
                </div>
                <div className="trust-card-info">
                  <h4>Compassionate Support</h4>
                  <p>Building warm, reliable medical bonds across pediatric, adult, and geriatric patient groups.</p>
                </div>
              </div>
            </div>

          </div>

          {/* Right Column: Interactive Appointment callback Form */}
          <div className="contact-form-wrapper animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
            <div className="form-card glass-card">
              
              {!formSubmitted ? (
                <>
                  <h3>Request a Callback</h3>
                  <p className="form-subtitle">Leave your details and we will call you to schedule a booking.</p>
                  
                  <form onSubmit={handleSubmit} className="appointment-form">
                    
                    <div className="form-group">
                      <label htmlFor="name">Full Name *</label>
                      <input 
                        type="text" 
                        id="name" 
                        name="name" 
                        required 
                        placeholder="Enter your name" 
                        value={formData.name}
                        onChange={handleInputChange}
                        className="form-input"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="phone">Contact Number *</label>
                      <input 
                        type="tel" 
                        id="phone" 
                        name="phone" 
                        required 
                        placeholder="Enter your contact number" 
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="form-input"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="symptoms">Pain symptoms / Rehabilitation needed</label>
                      <textarea 
                        id="symptoms" 
                        name="symptoms" 
                        rows="3" 
                        placeholder="e.g. Frozen shoulder, sciatica, knee replacement rehabilitation" 
                        value={formData.symptoms}
                        onChange={handleInputChange}
                        className="form-input"
                      ></textarea>
                    </div>

                    <div className="form-group">
                      <label htmlFor="date">Preferred Consulting Date</label>
                      <input 
                        type="date" 
                        id="date" 
                        name="date" 
                        value={formData.date}
                        onChange={handleInputChange}
                        className="form-input"
                      />
                    </div>

                    <button type="submit" className="btn btn-primary w-full form-submit-btn">
                      <Icon name="phone" size={18} />
                      <span>Submit Request</span>
                    </button>

                  </form>
                </>
              ) : (
                /* Success screen card state */
                <div className="form-success-box text-center">
                  <div className="success-icon-container">
                    <Icon name="checkcircle" size={48} className="success-check-icon animate-float" />
                  </div>
                  <h3>Request Received!</h3>
                  <p>
                    Thank you, <strong>{formData.name}</strong>. Dr. Anil Kumar's clinic will reach out to you at <strong>{formData.phone}</strong> shortly.
                  </p>
                  
                  {/* Secondary WhatsApp accelerator action */}
                  <div className="whatsapp-accelerator">
                    <p>Want an instant reply? Click below to send these details directly via WhatsApp:</p>
                    <button onClick={handleWhatsAppSubmit} className="btn btn-accent w-full flex-center">
                      <Icon name="calendar" size={18} />
                      <span>Instant WhatsApp Callback</span>
                    </button>
                  </div>

                  <button 
                    onClick={() => { setFormSubmitted(false); setFormData({ name: '', phone: '', symptoms: '', date: '' }); }} 
                    className="btn btn-outline-white w-full form-reset-btn"
                  >
                    Send Another Request
                  </button>
                </div>
              )}

            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Contact;
